import { render, staticRenderFns } from "./HolidaysGroup.vue?vue&type=template&id=2d840034"
import script from "./HolidaysGroup.vue?vue&type=script&lang=js"
export * from "./HolidaysGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports